import GroupsTable from './groups-table';
import { useMembershipGroupsQuery } from '@/hooks/membership-group/queries/use-membership-groups.query';
import Skeleton from 'react-loading-skeleton';

export default function GroupsPanel() {
  const { data, isPending, isError } = useMembershipGroupsQuery();

  return (
    <div className="grow">
      {/* Panel body */}
      <div className="p-6 space-y-6">
        <h2 className="text-2xl text-gray-800 dark:text-gray-100 font-bold mb-5">Grupper</h2>

        <section>
          <h2 className="text-xl leading-snug text-gray-800 dark:text-gray-100 font-bold mb-1">Dina grupper</h2>
          <div className="text-sm mb-2">Har kan du se och hantera dina grupper.</div>
          {data ? <GroupsTable membershipGroups={data} /> : <Skeleton height={200} />}
        </section>
      </div>
    </div>
  );
}
